export const BasicHttpHeaders = {
  "user-agent": "TossPaymentsIntegrationGuide MCP",
};
